 <div class="container mt-4" *ngIf="periodId || reportResponseId">
    <div class="row">
        <!-- Formulario -->
        <div [class.col-md-8]="isRContainersVisible" [class.col-md-12]="!isRContainersVisible">

            <div class="d-flex justify-content-end align-items-center mb-3">
                <button class="btn btn-primary btn-sm" (click)="toggleRContainers()">
                    <i [class]="isRContainersVisible ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
                </button>
            </div>

            <form [formGroup]="conceptResponseForm">

                <div class="row">
                    <div class="mb-2 col-md-6">
                        <label for="conceptSelect" class="form-label"><b>Seleccionar Concepto</b></label>
                        <select id="conceptSelect" class="form-select" formControlName="employeeConceptId"
                            (change)="verifyConceptResponse($event)">
                            <option selected>Elige un concepto...</option>
                            <option *ngFor="let c of concepts" [value]="c._id">
                                {{ c.concept.name }}: {{c.value | number:'1.0-0':'es-ES'}} {{c.concept.payPercent ? '%'
                                : ''}} {{c.concept.basedOn.name}}
                            </option>
                        </select>
                    </div>
                    <!--Valor de conceptResponseForm-->
                    <div class="mb-3 col-md-2">
                        <label for="" class="form-label"><b>Valor Rendido</b></label>
                        <p class="form-control-plaintext p-2">{{ conceptResponseForm.get('value')?.value |
                            number:'1.0-0':'es-ES' }}</p>
                    </div>
                    <!--  -->
                    <!--Valor de conceptResponseForm-->
                    <div class="mb-3 col-md-2">
                        <label for="" class="form-label"><b>Valor a Pagar</b></label>
                        <p class="form-control-plaintext p-2">{{ conceptResponseForm.get('valueToPay')?.value |
                            number:'1.0-0':'es-ES' }}</p>
                    </div><!--  -->

                </div>

                <div class="row">
                    <!-- Comentario -->
                    <div class="mb-2 col-md-6">
                        <label for="commentInput" class="form-label"><b>Comentario</b></label>
                        <textarea id="commentInput" class="form-control" rows="3"
                            placeholder="Escribe tu comentario aquí..." formControlName="comment"></textarea>
                    </div>
                    <div class="mb-2 col-md-3">
                        <label for="voteSelect" class="form-label"><b>Voto</b></label>
                        <input type="text" class="form-control" placeholder="Ej: 2025-003" formControlName="vote" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">

                        <div class="row">
                            <div class="col-md-3"> <label for="" class="form-label mb-3 me-2"><b>Gastos</b></label>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <button type="button" class="btn btn-primary btn-sm mb-3" (click)="onAddExpense()" 
                                [disabled]="userCanEdit==false">
                                Agregar Gasto
                            </button>
                        </div>

                        <table class="table table-hover table-sm align-middle border border-secondary rounded-4">
                            <thead class="table-primary text-center form-label-sm">
                                <tr>
                                    <th>Descripción</th>
                                    <th>Monto</th>
                                    <th>Adjuntos</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let expense of expenses" class="text-center form-label-sm">

                                    <td>{{ expense.description }}</td>
                                    <td>${{ expense.value | number: '1.0-0':'es-ES' }}</td>
                                    <td class="text-start">
                                        <div *ngIf="expense.attachments?.length > 0; else noAttachments">
                                            <ul class="list-unstyled mb-0">


                                                <li *ngFor="let attachment of expense.attachments">
                                                    <button class="btn btn-outline-primary btn-sm mt-1"
                                                        title="Ver Adjunto" (click)="onOpenAttachment(attachment)">
                                                        <i class="fas fa-folder"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <ng-template #noAttachments>
                                            <span class="text-muted">Sin adjuntos</span>
                                        </ng-template>
                                    </td>
                                    <td>
                                        <button class="btn btn-warning btn-sm me-1" title="Editar" [disabled]="userCanEdit==false"
                                             (click)="onEditExpense(expense)">
                                            <i class="bi bi-pencil-square"></i>
                                        </button>
                                        <button class="btn btn-danger btn-sm" title="Eliminar" [disabled]="userCanEdit==false"
                                             (click)="onDeleteExpense(expense)">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!--                 <pre>{{conceptResponseForm.value | json}}</pre>
                <pre>{{conceptResponseId | json}}</pre>
                <pre>{{expenseForm.value | json}}</pre> 

                <pre>savingCR: {{ savingCR }}</pre>-->

                <div class="row">

                   <!--  <div class="col-md-1">
                        <button type="button" class="btn btn-secondary btn-sm "
                            >Editar*</button>
                    </div> -->
                    <div class="col-md-2">
                        <button type="button" class="btn btn-success btn-sm" [disabled]="userCanEdit==false"
                            (click)="saveConceptResponse(false)">Guardar Cambios</button>
                    </div>

                   <!--  <div class="col-md-6">
                        <p *ngIf="isEditCR"> * Puedes editar la información haciendo click en "Editar" y luego "Guardar
                            Cambios"</p>
                    </div> -->
                </div>

                <!-- <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary btn-sm">Cancelar</button>
                   <button type="button" class="btn btn-success btn-sm px-3">Enviar</button>

                </div> -->
            </form>
        </div>

        <!-- Contenedores Derechos -->
        <div *ngIf="isRContainersVisible" class="col-md-4">
            <div class="row">
                <!-- Contenedor Superior Derecho -->
                <!--  <div class="col-12 mb-3">
                </div> -->
                <!-- Contenedor Inferior Derecho -->
                <div class="col-12 mb-3">
                    <app-list-votes></app-list-votes>
                </div>
                <!-- Contenedor Inferior Derecho 2 -->
                <div class="col-12">
                    <app-calculator></app-calculator>
                </div>
            </div>
        </div>

    </div>


    <div #addExpenseModal class="modal fade" id="addExpenseModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addExpenseModalLabel">Agregar Gasto</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form [formGroup]="expenseForm">
                         <div class="mb-3">
                            <label for="expenseAmount" class="form-label">Monto</label>
                            <input type="number" id="expenseAmount" class="form-control" placeholder="Monto del gasto"
                                formControlName="value" />
                        </div>
                        <div class="mb-3">
                            <label for="expenseDescription" class="form-label">Descripción</label>
                            <input type="text" id="expenseDescription" class="form-control"
                                placeholder="Descripción del gasto" formControlName="description" />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Adjuntos</label>
                            <input #fileInput type="file" class="form-control" multiple
                                (change)="onFilesSelected($event)" />

                            <ul class="list-group mt-2">
                                <li *ngFor="let file of selectedFiles"
                                    class="list-group-item d-flex justify-content-between align-items-center">
                                    {{ file.name }}
                                    <button type="button" class="btn btn-danger btn-sm"
                                        (click)="removeSelectedFile(file)">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </li>
                            </ul>
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancelar</button>
                    <button type="button" class="btn btn-primary me-2" (click)="onSaveExpense()">Guardar</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal para ver adjunto en pantalla completa -->
    <div class="modal fade" #AttachmentModal tabindex="-1" class="modal fade" aria-hidden="true">
        <div class="modal-dialog modal-xl" >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-primary" id="viewAttachmentModalLabel">Visor de Adjuntos</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                </div>

                <div class="modal-body"> 
                    <app-attachment-viewer>
                    </app-attachment-viewer>
                </div>
                <div class="modal-footer">

                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!periodId && !reportResponseId" class="alert alert-warning mt-4">
    <p>
        No se ha seleccionado un periodo. Ni un Id de Reporte, por favor, selecciona un periodo en la pestaña "Informe" para poder continuar.
    </p>
</div>